import { Component, effect, input, signal } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { EvTimePeriodFilterComponent, ILocalTimePeriodFilter, IOutgoingTimePeriodFilter, IRangeToMonth, TimePeriodActionTrigger } from "ev-time-period-filter";
import { defaultNumberOfMonthsToShow, NewDwellingTimePeriodModel } from "../new-dwellings-filter.model";

@Component({
    selector: "new-dwellings-filter-time-period",
    imports: [EvTimePeriodFilterComponent],
    templateUrl: "./new-dwellings-filter-time-period.component.html",
    styleUrl: "./new-dwellings-filter-time-period.component.scss",
})
export class NewDwellingsFilterTimePeriodComponent {
    filterForm = input.required<FieldTree<NewDwellingTimePeriodModel>>();

    // "Periode tilbake i tid" presets — design order, 5 år (60 mnd) initial. Plus "Alle" via showAllOptionInRange.
    rangeToMonthList: IRangeToMonth[] = [
        { key: 5, monthValue: 120, unitsDisplay: "år", unitsAmountDisplay: "10" },
        { key: 4, monthValue: 60, unitsDisplay: "år", unitsAmountDisplay: "5", initial: true },
        { key: 3, monthValue: 24, unitsDisplay: "år", unitsAmountDisplay: "2" },
        { key: 2, monthValue: 12, unitsDisplay: "år", unitsAmountDisplay: "1" },
        { key: 1, monthValue: 6, unitsDisplay: "mnd", unitsAmountDisplay: "6" },
        { key: 0, monthValue: 1, unitsDisplay: "mnd", unitsAmountDisplay: "1", hide: true },
    ];

    defaultValue: ILocalTimePeriodFilter = {
        useFromToDate: false,
        numberOfMonthsToShow: defaultNumberOfMonthsToShow,
        fromDate: undefined,
        toDate: undefined,
        isAllSelected: false,
    };

    selectedValue: ILocalTimePeriodFilter = { ...this.defaultValue };

    constructor() {
        // Keep the widget's selected period in sync with the form.
        // fromDate/toDate are Date|null in the model; ILocalTimePeriodFilter expects Date|undefined.
        effect(() => {
            this.selectedValue = {
                useFromToDate: this.filterForm().useFromToDate().value(),
                numberOfMonthsToShow: this.filterForm().numberOfMonthsToShow().value(),
                fromDate: this.filterForm().fromDate().value() ?? undefined,
                toDate: this.filterForm().toDate().value() ?? undefined,
                isAllSelected: this.filterForm().isAllSelected().value(),
            };
        });
    }

    onChange(event: IOutgoingTimePeriodFilter): void {
        const field = this.filterForm();
        const current = field().value();
        console.log("time", event);
        if (event.actionTrigger === TimePeriodActionTrigger.SelectAll) {
            // Tidsperiode — "Alle" (no time restriction)
            field().value.set({ ...current, isAllSelected: true, useFromToDate: false, numberOfMonthsToShow: event.numberOfMonthsToShow ?? null, fromDate: null, toDate: null });
        } else if (event.useFromToDate) {
            // Tidsperiode — explicit from/to dates (also covers "Hittil i år")
            field().value.set({ ...current, isAllSelected: false, useFromToDate: true, numberOfMonthsToShow: event.numberOfMonthsToShow ?? null, fromDate: event.fromDate ?? null, toDate: event.toDate ?? null });
        } else {
            // Tidsperiode — range mode (period back in time)
            field().value.set({
                ...current,
                isAllSelected: false,
                useFromToDate: false,
                numberOfMonthsToShow: event.numberOfMonthsToShow ?? defaultNumberOfMonthsToShow,
                fromDate: null,
                toDate: null,
            });
        }
    }
}
